import { useLazyQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';
import {
  eligibilityLookupSlice,
  MEMBER_CHECK_BY_CODE,
} from '@pass-frontend/features/facility-checkin/data-access';

export const useMemberCode = () => {
  const [fetchMemberByCode, { loading, data, error }] = useLazyQuery<
    any,
    { code: string }
  >(MEMBER_CHECK_BY_CODE, {
    fetchPolicy: 'no-cache',
  });

  const dispatch = useDispatch();
  if (data?.memberCheckForCode || data?.memberCheckForCodeV2) {
    dispatch(
      eligibilityLookupSlice.actions.setMemberDetails(
        data?.memberCheckForCode || data?.memberCheckForCodeV2,
      ),
    );
  }

  return {
    loading,
    error,
    data,
    //ts-ignore
    memberCheckForCode: data?.memberCheckForCode || data?.memberCheckForCodeV2,
    fetchMemberByCode: (code: string) => {
      fetchMemberByCode({
        variables: { code },
      });
    },
  };
};
